import { useCallback, useState } from "react";
import { archivePathway, duplicatePathway, listPathways } from "./adminApi";
// Relative: a pure hook, resolvable under Jest without a shim.
import useAdminLoad from "../hooks/useAdminLoad";

/**
 * The practitioner's pathway list (`GET /pathways`, updated_at desc, contract §5.1) and
 * the two writes its card menu owns: archive and duplicate. Editing is the builder's.
 *
 * The writes REJECT with the raw axios error. The screen turns it into a sentence through
 * pathways/errors.js, because only the screen has a bound `t`. After an archive the list
 * is read again, since its order (updated_at) and statuses are the server's. A duplicate
 * resolves the NEW draft, which the screen opens in the builder.
 *
 * @returns {{
 *   rows: object[]|null,   PathwayListItem[]; null until the first read succeeds
 *   loading: boolean, error: any, reload: () => Promise<void>,
 *   archive: (id: string) => Promise<void>,
 *   duplicate: (id: string) => Promise<object>,   the new AdminPathway
 * }}
 */
export default function usePathwayAdminList() {
  const [rows, setRows] = useState(null);
  const load = useCallback(async () => { setRows(await listPathways()); }, []);
  const { loading, loadError, reload } = useAdminLoad(load);

  const archive = useCallback(async (id) => {
    await archivePathway(id);
    await reload();
  }, [reload]);

  const duplicate = useCallback((id, lang) => duplicatePathway(id, { lang }), []);

  return { rows, loading, error: loadError, reload, archive, duplicate };
}
